const requireComponent = require.context('./', true, /\.js$/);

requireComponent.keys().forEach(fileName => {
  if (fileName === './index.js') { return; }

  requireComponent(fileName);
});
